import React from 'react';
import { useTranslation } from '../../../shared/i18n';

// Configuration for subscription-enabled activity types
// Labels are translation keys under "subscriptionSelector"
const SUBSCRIPTION_CONFIG = {
  duolingo: {
    checkboxId: 'duolingo-super-checkbox',
    testId: 'duolingo-super-checkbox',
    labelKey: 'duolingo'
  },
  brilliant: {
    checkboxId: 'brilliant-premium-checkbox',
    testId: 'brilliant-premium-checkbox',
    labelKey: 'brilliant'
  },
  art_workout: {
    checkboxId: 'art-workout-pro-checkbox',
    testId: 'art-workout-pro-checkbox',
    labelKey: 'art_workout'
  }
};

/**
 * SubscriptionSelector - Checkbox for premium subscription status
 *
 * Shows a checkbox for parents to indicate if their child's account
 * has been upgraded to a premium subscription.
 * Shown for Duolingo (Super/Max), Brilliant (Premium), and ArtWorkout (PRO) activities.
 */
const SubscriptionSelector = ({
  activityType,
  hasSubscription,
  onToggle,
  isTestMode = false
}) => {
  const { t } = useTranslation();
  const config = SUBSCRIPTION_CONFIG[activityType];

  // Only show for activity types with subscription support
  if (!config) {
    return null;
  }

  const handleChange = (e) => {
    onToggle(e.target.checked);
  };

  const label = t(`subscriptionSelector.${config.labelKey}`);

  return (
    <div className="mb-4" {...(isTestMode && { 'data-testid': 'subscription-selector' })}>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={config.checkboxId}
          checked={hasSubscription}
          onChange={handleChange}
          {...(isTestMode && { 'data-testid': config.testId })}
        />
        <label className="form-check-label" htmlFor={config.checkboxId}>
          <span className="fw-medium">{label}</span>
        </label>
      </div>
    </div>
  );
};

export default SubscriptionSelector;
